import PropTypes from 'prop-types';

import { BannerLayout, BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';

import style from './style.module.less';

const FulfillmentProviderRegistrationError = ({ errorMessage, clearErrorMessage }) => {
  return (
    <BannerMessageV2
      content={<div className={style['content-container']}>{errorMessage}</div>}
      layout={BannerLayout.Inline}
      onClose={clearErrorMessage}
      status={BannerStatus.Error}
    />
  );
};

FulfillmentProviderRegistrationError.propTypes = {
  errorMessage: PropTypes.string.isRequired,
  clearErrorMessage: PropTypes.func.isRequired,
};

export default FulfillmentProviderRegistrationError;
